
export function setConnInfo(connInfo) {
  sessionStorage.setItem('X-WEBPHONE-CONN', JSON.stringify(connInfo));
}

export function removeConnInfo() {
  sessionStorage.removeItem('X-WEBPHONE-CONN');
}

export function getConnInfo() {
  // refreshSession();
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  const conn = sessionStorage.getItem('X-WEBPHONE-CONN');
  if (!conn) {
    return null;
  }
  return JSON.parse(conn);
}

// export function getBaseUrl() {
//   if (typeof window === "undefined") {
//     return '';
//   }
//   const baseUrl = {
//     dev: 'http://localhost:8080',
//     nde: `${window.location.origin}`,
//   };
//   if (window.location.origin.includes('localhost') || window.location.origin.includes('127.0.0.1')) {
//     return baseUrl.dev;
//   }
//   return baseUrl.nde;
// }
